<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>等级流失</span>
        </div>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>天</span>
          </div>
          <el-form ref="queryForm" :model="queryParams" :inline="true">
            <el-form-item label="国家" prop="startDate">
              <el-select v-model="queryParams.country" placeholder="请选择">
                <el-option
                  v-for="item in country"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker
                v-model="queryParams.startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @keyup.enter.native="handleQuery(1)"
              />
            </el-form-item>
            <!--          <el-form-item label="结束日期" prop="endDate">-->
            <!--            <el-date-picker-->
            <!--              v-model="queryParams.endDate"-->
            <!--              type="date"-->
            <!--              placeholder="选择日期"-->
            <!--              value-format="yyyy-MM-dd"-->
            <!--              @keyup.enter.native="handleQuery"-->
            <!--            />-->
            <!--          </el-form-item>-->
            <el-form-item>
              <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery(1)">查询</el-button>
              <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            </el-form-item>
          </el-form>

          <el-table
            :data="tableData"
            border
            show-summary
            :summary-method="getSummaries"
            style="width: 100%"
          >
            <el-table-column
              prop="level"
              label="等级"
              width="100px"
            />
            <el-table-column
              prop="d1"
              label="次日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d2"
              label="3日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d3"
              label="4日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d4"
              label="5日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d5"
              label="6日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d6"
              label="7日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d14"
              label="15日"
              :formatter="numFormatter"
            />
            <el-table-column
              prop="d29"
              label="30日"
              :formatter="numFormatter"
            />
          </el-table>
          <echartsDay ref="lossDay" />
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>等级</span>
          </div>

          <el-form ref="queryForm" :model="queryParams" :inline="true">
            <el-form-item label="国家" prop="startDate">
              <el-select v-model="queryParams.country" placeholder="请选择">
                <el-option
                  v-for="item in country"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker
                v-model="queryParams.startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @keyup.enter.native="handleQuery(2)"
              />
            </el-form-item>
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker
                v-model="queryParams.endDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @keyup.enter.native="handleQuery(2)"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery(2)">查询</el-button>
              <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            </el-form-item>
          </el-form>
          <el-table
            :data="tableDataLevel"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="date"
              label="日期"
              width="100px"
            />
            <el-table-column
              v-for="(item, index) in levelData"
              :key="index"
              :label="'等级'+item"
              width="100px"
            >
              <template v-slot:default="scope">
                {{ scope.row.level_data[item] }}%
              </template>
            </el-table-column>
          </el-table>
          <echartsLevel ref="lossLevel" />

        </el-card>

      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { getLevelLoss, getLevelLoss2 } from '@/api/statistics/user_remain'
import echartsDay from '@/views/config/level-loss/components/echart-day.vue'
import echartsLevel from '@/views/config/level-loss/components/echart-level.vue'

export default {
  name: 'LevelLoss',
  components: {
    echartsDay,
    echartsLevel
  },
  data() {
    return {
      activeName: 'day',
      platForm: [{ label: '全部', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }],
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        platForm: ''
      },
      loading: false,
      options: [],
      tableData: [],
      tableDataLevel: [],
      date: [],
      levelData: []
    }
  },
  created() {
    this.getTables()
    this.getLevelLossLevel()
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = (Math.floor(sums[index] * 100) / 100) + '%'
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery(typ) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (typ === 2 && this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      this.loading = true
      if (typ === 1) {
        this.getTables()
      } else {
        this.getLevelLossLevel()
      }
    },
    getTables() {
      getLevelLoss(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          this.tableData = this.$refs.lossDay.refresh(res)
          this.country = [{ value: '', label: '全部' }]
          for (const i in res.data.country) {
            this.country.push({ value: i, label: res.data.country[i] })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getLevelLossLevel() {
      getLevelLoss2(this.queryParams).then(res => {
        this.loading = false
        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        this.tableDataLevel = res.data.data
        for (let i = 1; i <= res.data.level; i++) {
          this.levelData.push(i)
        }
        this.country = [{ value: '', label: '全部' }]
        for (const i in res.data.country) {
          this.country.push({ value: i, label: res.data.country[i] })
        }
        this.$refs.lossLevel.refresh(res)
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px;
}
</style>
